import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Button, Input, Select } from "../../../controls";
import { DropLi, Model, UseForm } from "../../../hooks";
import { Alert, Form } from "../../../layout";
import * as actions from "../../../api/actions/actions";
import { connect } from "react-redux";
import { controller, endpoints } from "../../../api/actions/api";
import { RmvEmptyProp, ToFormData } from "../../../hooks/Method";

const AddEditPlan = (props) => {
  const { _post, _put, _authUser, _defHoa, setShowForm, updData, setPlans } =
    props;
  const { InvPlanMdl } = Model();
  const { InvPeriod } = DropLi();
  const {
    values,
    setValues,
    errors,
    setErrors,
    handleInpChg,
    resetFormControls,
  } = UseForm(InvPlanMdl);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    updData && setValues({ ...updData });
    return () => {
      resetFormControls();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updData]);

  const validateForm = () => {
    let temp = {};
    temp.name = values.name !== "" ? "" : "Title is required.";
    temp.duration = values.duration !== "" ? "" : "Duration is required.";
    temp.periodic = values.periodic !== "" ? "" : "Perodic type is required.";

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      const onComplete = (res) => {
        setLoading(false);
        if (res.status === 201 || res.status === 200) {
          if (setPlans && res.result.id) {
            updData
              ? setPlans((x) => [
                  ...x.map((j) => (j.id === res.result.id ? res.result : j)),
                ])
              : setPlans((x) => [res.result, ...x]);
          }
          setShowForm(false);
          setAlert({
            isOpen: true,
            type: "success",
            title: "Success",
            subTitle: `Plan ${updData ? "Edited" : "Added"} Successfully.`,
          });
        } else
          setAlert({
            isOpen: true,
            type: "error",
            title: "Error",
            subTitle: res.msg,
          });
      };
      if (values.id === 0) {
        values.hoaId = _defHoa.id;
        values.userId = _authUser.id;
        _post(
          endpoints.InvPlan + controller.Post,
          ToFormData(RmvEmptyProp(values)),
          null,
          onComplete
        );
      } else if (values.id !== 0) {
        _put(
          endpoints.InvPlan + controller.Put,
          ToFormData(RmvEmptyProp(values)),
          null,
          onComplete
        );
      }
    }
  };

  const handleClose = () => {
    setShowForm(false);
  };

  return (
    <div className="p-15 bg-white">
      <Form onSubmit={handleSubmit} noValidate>
        <Grid container spacing={3}>
          <div className="tx-center p-20 mt-30 mb-10 w-100pr dark-color">
            <h2 className="h fw-5 mb-5">{updData ? "Edit" : "Add"} Term</h2>
            <div className="pos-relative d-flex j-center">
              <div className="border-bottom w-60" />
            </div>
          </div>
          <Grid item xs={12}>
            <Input
              label="Title"
              name="name"
              value={values.name}
              error={errors.name}
              onChange={handleInpChg}
              fullWidth
              inputProps={{ maxLength: 200 }}
            />
          </Grid>
          <Grid item xs={6}>
            <Input
              label="Duration"
              name="duration"
              value={values.duration}
              error={errors.duration}
              onChange={handleInpChg}
              type="number"
              onInput={(e) => (e.target.value = e.target.value.slice(0, 30))}
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <Select
              label="Periodic Type"
              name="periodic"
              value={values.periodic}
              error={errors.periodic}
              onChange={handleInpChg}
              options={InvPeriod}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Button variant="text" size="large" onClick={handleClose} fullWidth>
              Cancel
            </Button>
          </Grid>
          <Grid item xs={12} md={6}>
            <Button loading={loading} size="large" type="submit" fullWidth>
              Save
            </Button>
          </Grid>
        </Grid>
      </Form>

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </div>
  );
};

const mapStateToProps = (state) => ({
  _authUser: state.storeData.authUser,
  _defHoa: state.storeData.defHoa,
});

const mapActionToProps = {
  _post: actions.post,
  _put: actions.put,
  _getById: actions.getById,
};

export default connect(mapStateToProps, mapActionToProps)(AddEditPlan);
